import {contentSlice} from '../../reducers/resources/content';
import {AppThunk} from '..';
import {httpService, HttpWrapperOptions} from '../../../shared/httpWrapper';
import {apiUrls} from '../../../shared/constants/urls';
import {FaqCategory, FeedbackThemeResponsePayload} from '../../../shared/models/api';
import {faqSlice} from '../../reducers/resources/faq';
import {feedbackThemesSlice} from '../../reducers/resources/feedbackThemes';
import {getApiRoute} from '../../../shared/pipes/getApiRoute';
import {Content} from '../../../shared/models/content';
import {mergeDeep} from '../../../shared/pipes';

export const getContent = (): AppThunk => {
  return async (dispatch, getState) => {
    const content = getState().resources.content;

    if (content.isLoaded) {
      return;
    }

    const url = getApiRoute(apiUrls.content);
    const options = new HttpWrapperOptions().RequestSequenceIdentificator('Content').Errors(false);
    const response = await httpService.get<Content>(url, options);

    if (!response) {
      return;
    }

    const newContent: Content = mergeDeep({}, content.data, response);
    dispatch(contentSlice.actions.setContent(newContent));
    dispatch(contentSlice.actions.setContentLoaded(true));
  };
};

export const getFaq = (): AppThunk => async (dispatch) => {
  const response = await httpService.get<FaqCategory[]>(getApiRoute(apiUrls.getFAQ));

  dispatch(faqSlice.actions.setFaq(response));
};

export const getFeedbackThemes = (): AppThunk => {
  return async (dispatch) => {
    const feedbackThemes = await httpService.get<FeedbackThemeResponsePayload[]>(
      getApiRoute(apiUrls.getFeedbackThemes),
    );
    dispatch(feedbackThemesSlice.actions.setFeedbackThemes(feedbackThemes));
  };
};
